import { render, staticRenderFns } from "./ElementList.vue?vue&type=template&id=f0e4c708&scoped=true"
import script from "./ElementList.vue?vue&type=script&lang=js"
export * from "./ElementList.vue?vue&type=script&lang=js"
import style0 from "./ElementList.vue?vue&type=style&index=0&id=f0e4c708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e4c708",
  null
  
)

export default component.exports